// src/components/AgendarMensagemModal.js
import React, { useState } from 'react';

function AgendarMensagemModal({ isOpen, onClose, onConfirmar }) {
  const [dados, setDados] = useState({
    numero_destinatario: '',
    nome_destinatario: '',
    mensagem: '',
    data_envio: '',
    hora_envio: '08:00',
    enviado_por: 'salatiel'
  });
  
  const [enviando, setEnviando] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validações
    if (!dados.numero_destinatario || dados.numero_destinatario.trim().length < 10) {
      alert('Digite um número de WhatsApp válido!');
      return;
    }
    
    if (!dados.mensagem || dados.mensagem.trim().length < 5) {
      alert('Digite uma mensagem!');
      return;
    }
    
    if (!dados.data_envio) {
      alert('Selecione a data de envio!');
      return;
    }
    
    setEnviando(true);
    
    try {
      const dataHoraEnvio = `${dados.data_envio}T${dados.hora_envio}:00`;
      
      await onConfirmar({
        numero_destinatario: dados.numero_destinatario.trim(),
        nome_destinatario: dados.nome_destinatario.trim() || null,
        mensagem: dados.mensagem.trim(),
        data_envio: dataHoraEnvio,
        enviado_por: dados.enviado_por
      });
      
      // Limpar formulário
      setDados({
        numero_destinatario: '',
        nome_destinatario: '',
        mensagem: '',
        data_envio: '',
        hora_envio: '08:00',
        enviado_por: 'salatiel'
      });
      
      onClose();
    } catch (error) {
      console.error('Erro ao agendar mensagem:', error);
      alert('Erro ao agendar mensagem!');
    } finally {
      setEnviando(false);
    }
  };

  

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content modal-large" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>📅 Agendar Mensagem WhatsApp</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            
            {/* DADOS DO DESTINATÁRIO */}
            <div className="info-section">
              <h3>👤 Destinatário</h3>
              <div className="form-grid">
                <div className="form-group">
                  <label>Número WhatsApp *</label>
                  <input
                    type="tel"
                    value={dados.numero_destinatario}
                    onChange={(e) => setDados({...dados, numero_destinatario: e.target.value})}
                    placeholder="16999999999"
                    required
                  />
                  <small>Apenas números (DDD + número)</small>
                </div>
                
                <div className="form-group">
                  <label>Nome (Opcional)</label>
                  <input
                    type="text"
                    value={dados.nome_destinatario}
                    onChange={(e) => setDados({...dados, nome_destinatario: e.target.value})}
                    placeholder="Nome do contato"
                  />
                  <small>Para identificação na lista</small>
                </div>
              </div>
            </div>

            {/* MENSAGEM */}
            <div className="info-section">
              <h3>💬 Mensagem</h3>
              <div className="form-group">
                <textarea
                  value={dados.mensagem}
                  onChange={(e) => setDados({...dados, mensagem: e.target.value})}
                  placeholder="Digite a mensagem que será enviada...&#10;&#10;Exemplo:&#10;Bom dia! Não esqueça de comprar o equipamento que conversamos."
                  rows="8"
                  required
                  style={{
                    width: '100%',
                    padding: '10px',
                    borderRadius: '4px',
                    border: '1px solid #ddd',
                    fontSize: '14px',
                    fontFamily: 'inherit',
                    resize: 'vertical'
                  }}
                />
                <small>Caracteres: {dados.mensagem.length}</small>
              </div>
            </div>

            {/* ENVIAR DE QUAL NÚMERO */}
            <div className="info-section">
              <h3>📱 Enviar de Qual Número?</h3>
              <div className="radio-group">
                <label className="radio-option">
                  <input
                    type="radio"
                    name="enviado_por"
                    value="salatiel"
                    checked={dados.enviado_por === 'salatiel'}
                    onChange={(e) => setDados({...dados, enviado_por: e.target.value})}
                  />
                  <span>👤 Salatiel - GVS (Pessoal)</span>
                </label>
                
                {/* DESCOMENTE quando tiver a instância da empresa */}
                {/*
                <label className="radio-option">
                  <input
                    type="radio"
                    name="enviado_por"
                    value="empresa"
                    checked={dados.enviado_por === 'empresa'}
                    onChange={(e) => setDados({...dados, enviado_por: e.target.value})}
                  />
                  <span>🏢 Grupo GVS (Institucional)</span>
                </label>
                */}
              </div>
            </div>

            {/* DATA E HORA DE ENVIO */}
            <div className="info-section">
              <h3>⏰ Agendamento</h3>
              <div style={{
                background: '#e3f2fd',
                padding: '15px',
                borderRadius: '8px',
                marginBottom: '20px',
                border: '1px solid #2196f3'
              }}>
                <p style={{margin: 0, fontSize: '14px', color: '#1976d2'}}>
                  📱 <strong>A mensagem será enviada automaticamente no horário agendado!</strong>
                </p>
              </div>

              <div className="form-grid">
                <div className="form-group">
                  <label>📅 Data de Envio: *</label>
                  <input
                    type="date"
                    value={dados.data_envio}
                    onChange={(e) => setDados({...dados, data_envio: e.target.value})}
                    required
                    style={{
                      width: '100%',
                      padding: '10px',
                      borderRadius: '4px',
                      border: '1px solid #ddd',
                      fontSize: '14px'
                    }}
                  />
                </div>

                <div className="form-group">
                  <label>🕐 Horário de Envio: *</label>
<input
  type="time"
  value={dados.hora_envio}
  onChange={(e) => setDados({...dados, hora_envio: e.target.value})}
  required
  style={{
    width: '100%',
    fontSize: '14px',
    padding: '8px',
    border: '1px solid #ddd',
    borderRadius: '4px'
  }}
/>
<small>Escolha qualquer horário</small>
                </div>
              </div>
            </div>

            {/* PRÉVIA */}
            <div className="info-section">
              <h3>👁️ Prévia</h3>
              <div style={{
                background: '#f5f5f5',
                padding: '15px',
                borderRadius: '8px',
                whiteSpace: 'pre-wrap',
                fontSize: '14px',
                border: '1px solid #ddd',
                minHeight: '80px'
              }}>
                {dados.mensagem || 'Sua mensagem aparecerá aqui...'}
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button 
              type="button" 
              onClick={onClose} 
              className="btn-secondary"
              disabled={enviando}
            >
              Cancelar
            </button>
            <button 
              type="submit" 
              className="btn-primary"
              disabled={enviando}
              style={{
                backgroundColor: '#2196f3',
                color: 'white'
              }}
            >
              {enviando ? '⏳ Agendando...' : '📅 Agendar Mensagem'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AgendarMensagemModal;
